module.exports = __webpack_public_path__ + "img/Failed_Box@2x.b7837302.png";